import Tools from '@/components/Tools';

const ToolsPage = () => {
  return <Tools />;
};

export default ToolsPage;
